"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _WriteScopedButton = _interopRequireDefault(require("lead-flows-ui/components/common/WriteScopedButton"));

var LastStepButton =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(LastStepButton, _PureComponent);

  function LastStepButton() {
    (0, _classCallCheck2.default)(this, LastStepButton);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LastStepButton).apply(this, arguments));
  }

  (0, _createClass2.default)(LastStepButton, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.secondaryNavigation." + suffix;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          label = _this$props.label;
      return _react.default.createElement(_WriteScopedButton.default, {
        disabled: disabled,
        onClick: onClick,
        use: "primary"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey(label)
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        label: _react.PropTypes.string,
        disabled: _react.PropTypes.bool,
        onClick: _react.PropTypes.func
      };
    }
  }]);
  return LastStepButton;
}(_react.PureComponent);

exports.default = LastStepButton;
module.exports = exports.default;